import React from "react";
import { Icons } from "../../atoms/Icons";
import "./application-stepper.scss";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { Link } from "react-router-dom";
import livechat from "../../assets/live-chat-blue.png";
import { Col, Row } from "react-bootstrap";

const ApplicationStepper = (props) => {
  const { raSteps } = props;
  const openZendeskChat = (e) => {
    e.preventDefault();
    if (typeof window.zE !== "undefined") {
      window.zE("messenger", "open");
    } else {
      console.log("zendesk widget is not loaded yet!");
    }
  };
  return (
    <div className="application-steps-wrapper">
      <div className="application-steps-container">
        <ul className="main-steps">
          {raSteps?.map((item, index) => {
            index = index + 1;
            return (
              <>
                <li key={index} className="main-step-list">
                  {item.isBegin ? (
                    <span className="step-num-outer">
                      <span className="step-num-indicator">{index}</span>
                    </span>
                  ) : item.isUpComing ? (
                    <span className="step-num-grey">{index}</span>
                  ) : (
                    <Icons
                      variant="icon-twenty-eight-px"
                      iconname="form-fields-success-tick"
                      data-testid="form-fields-success-tick"
                    />
                  )}
                  <span
                    className={
                      (item.identifier ===
                        RA_STEPS_IDENTIFIERS.RETIREMENT_DATE_AND_GUIDANCE ||
                        item.identifier ===
                          RA_STEPS_IDENTIFIERS.CHOOSING_YOUR_RETIREMENT ||
                        item.identifier ===
                          RA_STEPS_IDENTIFIERS.RA_IDENTITY_AND_VERIFICATION) &&
                      item.isComplete === true
                        ? "step-name-ra-date-guidance"
                        : "step-name"
                    }
                  >
                    {item.title === "Identification and verification"
                      ? "Identity and verification"
                      : item.title == "Declaration process"
                        ? "Declaration"
                        : item.title}
                  </span>
                  {item.isSubStepsOpen && item.isBegin ? (
                    <ul className="sub-steps" key={index}>
                      {item.subSteps?.map((step, stepIndex) => {
                        return (
                          <li key={stepIndex} className="sub-step-list">
                            <Row>
                              {step.isSubBegin ? (
                                <Col lg={2} md={2}>
                                  <Icons
                                    variant="icon-sixteen-px"
                                    iconname="progress-bar-current"
                                  />
                                </Col>
                              ) : step.isSubUpComing ? (
                                <Col lg={2} md={2}>
                                  <Icons
                                    variant="icon-sixteen-px"
                                    iconname="progress-bar-upcoming"
                                  />
                                </Col>
                              ) : (
                                <Col lg={2} md={2}>
                                  <Icons
                                    variant="icon-sixteen-px"
                                    iconname="progress-bar-complete"
                                  />
                                </Col>
                              )}
                              <Col lg={10} md={10} className="sub-step-name">
                                {step.name}
                              </Col>
                            </Row>
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
                {index != raSteps?.length ? <hr /> : ""}
              </>
            );
          })}
        </ul>
      </div>
      <div className="ra-help-section">
        <p className="mb-2">
          <Icons variant="icon-sixteen-px" iconname="faq" />{" "}
          <Link to="/learn/support/help-guides/" className="help-guidance-link">
            Help & guidance
          </Link>
        </p>
        <p className="mb-0">
          <img src={livechat} className="live-chat-icon" />{" "}
          <a onClick={openZendeskChat} className="live-chat-link">
            Live chat
          </a>{" "}
        </p>
      </div>
    </div>
  );
};

export default ApplicationStepper;
